export namespace LmEventNames {
  /** @deprecated **/
  export const FORCE_RELOGIN = "FORCE_RELOGIN"
  /** @deprecated **/
  export const FIREBASE_EMAIL_CHANGED = "FIREBASE_EMAIL_CHANGED"
  export const LOGIN = "LOGIN"
  export const LOGOUT = "LOGOUT"
  export const USER_REAUTHENTICATED = "USER_REAUTHENTICATED"
  export const UPDATE_ID_TOKEN = "UPDATE_ID_TOKEN"
}

export type LmEvents = {
  /** @deprecated Use FORCE_RELOGIN instead */
  [LmEventNames.FIREBASE_EMAIL_CHANGED]: { email: string },
  /** @deprecated Replaced by LOGOUT + LOGIN flow */
  [LmEventNames.FORCE_RELOGIN]: { email?: string },
  [LmEventNames.LOGIN]: { email?: string },
  [LmEventNames.LOGOUT]: Record<string, never>,
  [LmEventNames.USER_REAUTHENTICATED]: { idToken: string },
  [LmEventNames.UPDATE_ID_TOKEN]: { idToken: string },
}
